import { render, staticRenderFns } from "./PtApply.vue?vue&type=template&id=43882012&scoped=true&"
import script from "./PtApply.vue?vue&type=script&lang=js&"
export * from "./PtApply.vue?vue&type=script&lang=js&"
import style0 from "./PtApply.vue?vue&type=style&index=0&id=43882012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43882012",
  null
  
)

export default component.exports